/** The application version, package.json's, which Vite's define inlines in place of the constant. */
export const version = __APP_VERSION__;
